angular.module('v3sWbtPlayerApp').factory('v3sBrowserInfoService', ["$window", "v3sContentConfig", function ($window, v3sContentConfig) {

    var isIosApp = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
    var isIosBrowser = (/(iPhone|iPod|iPad).*AppleWebKit/i.test(navigator.userAgent)) && !isIosApp && !window.navigator.standalone;
    var isIosWebApp = isIosApp && window.navigator.standalone;
    var isIosAppViversa = isIosApp && !window.navigator.standalone;
    var isIos = isIosApp || isIosBrowser;

    var isAndroid = navigator.userAgent.match(/Android/i);
    var isBlackBerry = navigator.userAgent.match(/BlackBerry/i);
    var isOperaMini = navigator.userAgent.match(/Opera Mini/i);
    var isWindowsMobile = navigator.userAgent.match(/IEMobile/i);
    var isTouchBrowser = 'ontouchstart' in window || navigator.maxTouchPoints;

    var isIE = /MSIE/.test(navigator.userAgent) || /Trident/.test(navigator.userAgent);

    var isViversaApp = false;
    try {
        // local cross-origin error 
        isViversaApp = (!!window.SCORMAPI && window.SCORMAPI == "ViversaApp") || (!!parent.SCORMAPI && parent.SCORMAPI == "ViversaApp");
    }catch(e){}

    var isBrowserWithoutAutoplay = !isViversaApp && !isIE;

    var isApp = isIosAppViversa || isViversaApp;
    var mobileFrame = !!window.parent && window.parent != window && (isIos || isAndroid || isBlackBerry) && !isApp;
    var maxWidth = v3sContentConfig.width - 1;

    var isResponsiveView = function () {
        return !!window.matchMedia && v3sContentConfig.responsive && !!window.matchMedia("(max-width: " +maxWidth + "px)").matches;
    };

    return {
        isIosBrowser: function () { return isIosBrowser },
        isIosWebApp: function () { return isIosWebApp },
        isIosAppViversa: function () { return isIosAppViversa },
        isViversaApp : function(){return isViversaApp},
        isBrowserWithoutAutoplay: function () { return isBrowserWithoutAutoplay },
        isTouchBrowser: function () { return isTouchBrowser },
        isMobileFrame: function () { return mobileFrame },
        isResponsiveView: isResponsiveView,
        isDesktopView: function () { return !isResponsiveView() }
    }
}]);